import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Emit, Watch, Component } from 'vue-property-decorator';
import { minLength, required, numeric } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const PHONE_INPUT_SEPARATOR = " ";
let PhoneNumberComponent = class extends Mixins(MagicConfigMixin, validationMixin) {
  constructor() {
    super(...arguments);
    this.prefix = "";
    this.number = "";
  }
  get phonePlaceholder() {
    if (!this.placeholder) {
      return this.$t("phone-number.number.placeholder") || this.$t("sign-up-step-two.mobile.placeholder");
    }
    return this.placeholder;
  }
  get phoneRegex() {
    return new RegExp(this.phoneValidator);
  }
  get phonePrefixes() {
    if (!this.prefixes) {
      return [];
    }
    const prefixArray = this.prefixes.split(",");
    return prefixArray.map((prefix) => {
      const trimmedPrefix = prefix.trim();
      return {
        name: trimmedPrefix,
        value: trimmedPrefix
      };
    });
  }
  onChange() {
    this.formBuilderChange();
    const prefix = this.$v.prefix.$invalid ? "" : this.prefix;
    const number = this.$v.number.$invalid ? "" : this.number;
    return [prefix, number].join(PHONE_INPUT_SEPARATOR);
  }
  formBuilderChange() {
    const value = [this.prefix, this.number].join(PHONE_INPUT_SEPARATOR);
    const isValid = !this.$v.prefix.$invalid && !this.$v.number.$invalid;
    return {
      value,
      isValid
    };
  }
  onValueChange() {
    if (!this.value) {
      return;
    }
    const [prefix = "", number = ""] = this.value.split(PHONE_INPUT_SEPARATOR);
    if (prefix !== this.prefix && !!prefix) {
      this.prefix = prefix;
    }
    if (number !== this.number && !!number) {
      this.number = number;
    }
  }
  preventNonDigits(event) {
    if (event.data && !/^\d$/.test(event.data)) {
      event.preventDefault();
    }
  }
};
__decorateClass([
  Prop(Boolean)
], PhoneNumberComponent.prototype, "optional", 2);
__decorateClass([
  Prop({
    type: String,
    default: `\\d{4,}`
  })
], PhoneNumberComponent.prototype, "phoneValidator", 2);
__decorateClass([
  Prop({ type: String, default: PHONE_INPUT_SEPARATOR })
], PhoneNumberComponent.prototype, "value", 2);
__decorateClass([
  Prop(String)
], PhoneNumberComponent.prototype, "prefixes", 2);
__decorateClass([
  Prop(String)
], PhoneNumberComponent.prototype, "placeholder", 2);
__decorateClass([
  Emit("change")
], PhoneNumberComponent.prototype, "onChange", 1);
__decorateClass([
  Emit("stand-alone-change")
], PhoneNumberComponent.prototype, "formBuilderChange", 1);
__decorateClass([
  Watch("value", { immediate: true })
], PhoneNumberComponent.prototype, "onValueChange", 1);
PhoneNumberComponent = __decorateClass([
  Component({
    name: "ui-phone-number",
    inheritAttrs: false,
    validations() {
      if (!this.optional) {
        return {
          prefix: {
            minLength: minLength(1),
            required
          },
          number: {
            isValidPhone: (value) => this.phoneRegex.test(`${value}`),
            required,
            numeric
          }
        };
      }
      return {
        prefix: {
          minLength: minLength(1)
        },
        number: {
          isValidPhone: this.optional && this.number ? (value) => this.phoneRegex.test(`${value}`) : () => true,
          numeric
        }
      };
    }
  })
], PhoneNumberComponent);

export default PhoneNumberComponent;
